import { Box, Chip, Radio } from "@mui/material"
import type { CellContext, ColumnDef } from "@tanstack/react-table"
import type { ReactElement } from "react"

import type { TestTemplate } from "@/graphql/codegen/graphql"
import {
  getTestTemplateComparisonLabel,
  getTestTemplateResultUomLabel,
} from "@/screens/ManageProducts/components/TestTemplates/utils"

export const useTestTemplateColumns: ColumnDef<TestTemplate>[] = [
  {
    accessorKey: "testTemplateId",
    id: "testTemplateId",
    header: "",
    cell: ({ row }: CellContext<TestTemplate, unknown>): ReactElement => {
      return (
        <Box className='space-x-5'>
          <Radio
            id={row.original.testTemplateId.toString()}
            checked={row.getIsSelected()}
            onClick={() => {
              if (row.getCanSelect()) {
                row.toggleSelected()
              }
            }}
            disabled={!row.getCanSelect()}
            name='testTemplateId'
            value={row.original.testTemplateId.toString()}
          />
        </Box>
      )
    },
    size: 50,
  },
  {
    accessorKey: "testNumber",
    header: "Test #",
    enableSorting: true,
    size: 100,
    cell: ({ row }) => row.original.externalSystemId,
  },
  {
    accessorKey: "description",
    header: "Description",
    enableSorting: true,
    size: 300,
    cell: ({ row }) => row.original.description,
  },
  {
    accessorKey: "resultsUnitOfMeasure",
    header: "Results UoM",
    enableSorting: false,
    cell: ({ row }) => getTestTemplateResultUomLabel(row.original.resultsUnitOfMeasure),
  },
  {
    accessorKey: "comparison",
    header: "Comparison",
    enableSorting: false,
    cell: ({ row }) => getTestTemplateComparisonLabel(row.original.comparison ?? ""),
  },
  {
    accessorKey: "status",
    header: "Status",
    cell: ({ row }: CellContext<TestTemplate, unknown>): ReactElement => {
      const isAssociated = row.original.isAssociatedWithProduct
      const status = isAssociated ? "Associated" : "Available"
      const color = isAssociated ? "error" : "success"

      return <Chip label={status} color={color} size='small' />
    },
    enableSorting: false,
  },
]
